import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IMemberShipPlan } from "../membershipplanModel";

export const getAllMemberShipPlans = createAsyncThunk(
  "MembershipPlan/FindAllMembershipPlan",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/FindAllMembershipPlan`,
        {
          PlanName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching MembershipPlans:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMembershipPlan = createAsyncThunk(
  "MembershipPlan/InsertMembershipPlan",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/InsertMembershipPlan`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching MembershipPlans:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMembershipPlan = createAsyncThunk(
  "MembershipPlan/UpdateMembershipPlan",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/UpdateMembershipPlan`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating MembershipPlan:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMembershipPlanById = createAsyncThunk(
  "MembershipPlan/FindByIDMembershipPlan",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/FindByIDMembershipPlan`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PlanName: result.PlanName,
        BussinessValue: result.BussinessValue,
        TicketCount: result.TicketCount,
        DomesticFlightCharge: result.DomesticFlightCharge,
        InternationalFlightCharge: result.InternationalFlightCharge,
        IsActive: result.IsActive ? 1 : 2,
      } as IMemberShipPlan;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching MembershipPlans:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMembershipPlan = createAsyncThunk(
  "MembershipPlan/DeleteMembershipPlan",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/DeleteMembershipPlan`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting MembershipPlan:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const MembershipPlanActiveInactive = createAsyncThunk(
  "MembershipPlan/ActiveInActiveMembershipPlan",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/ActiveInActiveMembershipPlan`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive MembershipPlan:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
